import styled from 'styled-components'
import { media } from '@/theme/tokens'

/** Row 1: Users + Trips (two wide cards). */
export const TopGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 20px;
	margin-bottom: 20px;

	${media.tabletWide} {
		grid-template-columns: 1fr;
	}
`

/** Row 2: Events + Ideas + Expenses (three cards). */
export const BottomGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 20px;

	${media.bentoCollapse} {
		grid-template-columns: 1fr 1fr;
	}
	${media.tablet} {
		grid-template-columns: 1fr;
	}
`

